<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <mtc-form-item label="label.tableName">
              <j-input :placeholder="$t('label.pleaseEnter', { field: $t('label.tableName') })" v-model="queryParam.tableName" />
            </mtc-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <mtc-form-item label="label.tableType">
              <j-multi-select-tag dictCode="cgform_table_type"
                                  v-model="queryParam.tableType_MultiString"
                                  :placeholder="$t('label.pleaseSelect', { field: $t('label.tableType') })" />
            </mtc-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <mtc-form-item label="label.tableDescription">
              <j-input :placeholder="$t('label.pleaseEnter', { field: $t('label.tableDescription') })" v-model="queryParam.tableTxt" />
            </mtc-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <mtc-button type="primary" @click="searchQuery" icon="search" text="button.search" />
              <mtc-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px" text="button.reset" />
              <!-- <j-super-query :fieldList="superQueryFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery" style="margin-left: 8px">-->
              <!-- 直接在内部写一个按钮即可，点击事件自动添加
              <a-button type="primary" ghost icon="clock-circle" style="margin-left: 8px">高级查询</a-button> -->
              <!-- </j-super-query>-->
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <mtc-button @click="handleAdd" type="primary" icon="plus" text="button.add" />
      <mtc-button @click="doCgformButton" type="primary" icon="highlight" text="button.customButton" />
      <mtc-button @click="doEnhanceJs" type="primary" icon="strikethrough" text="button.jsEnhancement" />
      <mtc-button @click="doEnhanceSql" type="primary" icon="filter" text="button.sqlEnhancement" />
      <mtc-button @click="doEnhanceJava" type="primary" icon="tool" text="button.javaEnhancement" />
      <mtc-button @click="doEnhanceGroovy" type="primary" icon="tool" text="button.groovyEnhancement" />
      <mtc-button @click="importOnlineForm" type="primary" icon="database" text="button.importDatabaseTable" />
      <mtc-button @click="goGenerateCode" type="primary" icon="database" text="button.codeGeneration" />
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDeleteCust">
            <a-popconfirm @confirm="batchDeleteCust">
              <mtcLangPopover slot="title" text="tip.isDelete" />
              <mtcLangPopover text="button.delete">
                <a>
                  <a-icon type="delete" />
                  {{ $t('button.delete') }}
                </a>
              </mtcLangPopover>
            </a-popconfirm>
          </a-menu-item>
        </a-menu>
        <mtc-button icon="down" text="button.batchOperation" />
      </a-dropdown>
    </div>
    <!-- table区域-begin -->
    <div>
      <a-alert style="margin: 10px 0">
        <template slot="message">
          <a-icon class="anticon ant-alert-icon" theme="filled" type="info-circle" />
          <span style="margin-left: 20px">
          <!-- 已选择 -->
          <mtcLangPopover text="tip.selected" />：
            <!-- 条数 -->
          <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>
            <!-- 单位 -->
          <mtcLangPopover text="tip.term" />
          <mtcLangPopover text="button.clear">
            <a style="margin-left: 24px" @click="onClearSelected">{{ $t('button.clear') }}</a>
          </mtcLangPopover>
        </span>
        </template>
      </a-alert>
      <a-table ref="table"
               size="middle"
               bordered
               rowKey="id"
               :columns="columns"
               :dataSource="dataSource"
               :pagination="ipagination"
               :loading="loading"
               :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
               @change="handleTableChange">
        <!-- 表头自定义渲染 -->
        <template v-for="(item, index) in columns" :slot="item.slotName">
          <mtcHeader :key="index" :text="item.slotName" />
        </template>
        <template slot="action" slot-scope="text, record">
          <mtcLangPopover text="button.edit">
            <a @click="handleEdit(record)">{{ $t('button.edit') }}</a>
          </mtcLangPopover>
          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">
              <mtcLangPopover text="button.more" />
              <a-icon type="down" />
            </a>
            <a-menu slot="overlay">
              <a-menu-item v-if="record.isDbSynch!='Y'">
                <mtcLangPopover text="button.synchronizeDatabase" @click="openSyncModal(record.id)" />
              </a-menu-item>
              <template v-if="record.isDbSynch=='Y' && record.tableType !== 3">
                <a-menu-item>
                  <mtcLangPopover text="button.functionTest" @click="goPageOnline(record)" />
                </a-menu-item>
                <a-menu-item>
                  <mtcLangPopover text="button.configureAddress" @click="handleOnlineUrlShow(record)" />
                </a-menu-item>
              </template>
              <a-menu-item>
                <mtcLangPopover text="button.accessControl" @click="goAuthConfig(record.id)" />
              </a-menu-item>
              <a-menu-item>
                <mtcLangPopover text="button.roleAuthorization" @click="doAuthConfig(record.id)" />
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('tip.areYouSureGenerateTheView')" @confirm="copyConfig(record.id)">
                  {{ $t('button.generateView') }}
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-if="record.hascopy == 1">
                <mtcLangPopover text="button.viewManagement" @click="showMyCopyInfo(record.id)" />
              </a-menu-item>
              <a-menu-item>
                <mtcLangPopover text="button.remove" @click="handleRemoveRecord(record.id)" />
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm :title="$t('tip.isDelete')" @confirm="handleDelete(record.id)" placement="left">
                  {{ $t('button.delete') }}
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </template>
        <template slot="dbsync" slot-scope="text">
          <span v-if="text==='Y'" style="color:limegreen">{{ $t('tip.synced') }}</span>
          <span v-if="text==='N'" style="color:red">{{ $t('tip.notSynced') }}</span>
        </template>
      </a-table>
    </div>
    <!-- table区域-end -->
    <!-- 表单区域 -->
    <onl-cgform-head-modal ref="modalForm" @ok="modalFormOk" />
    <!-- 提示online报表链接 -->
    <a-modal :title="onlineUrlTitle"
             :visible="onlineUrlVisible"
             @cancel="handleOnlineUrlClose">
      <template slot="footer">
        <mtc-button @click="handleOnlineUrlClose" style="margin-right: 8px" text="button.close" />
        <mtc-button type="primary" class="copy-this-text" :data-clipboard-text="onlineUrl" @click="onCopyUrl" text="button.copy" />
      </template>
      <p>{{ onlineUrl }}</p>
    </a-modal>
    <enhance-js ref="ehjs" />
    <!-- <enhance-groovy ref="ehgroovy" /> -->
    <!--<enhance-sql ref="ehsql"></enhance-sql>-->
    <!--<enhance-java ref="ehjava"></enhance-java>-->
    <trans-db2-online ref="transd2o" @ok="transOk" />
    <code-generator ref="cg" />
    <onl-cgform-button-list ref="btnList" />
    <onl-enhance-java-list ref="ehjava" />
    <onl-enhance-groovy-list ref="ehgroovy" />
    <onl-enhance-sql-list ref="ehsql" />
    <auth-manager ref="authManager" />
    <auth-setter ref="authSetter" />
    <!-- 同步数据库提示框 -->
    <a-modal :width="500"
             :height="300"
             :visible="syncModalVisible"
             @cancel="handleCancleDbSync"
             style="top:5%;height: 95%;">
      <template #title>
        <mtcLangPopover text="modalTitle.synchronizeTheDatabase" />
      </template>
      <a-radio-group v-model="synMethod">
        <a-radio style="display: block;width: 30px;height: 30px" value="normal">{{ $t('tip.normalSync') }}</a-radio>
        <a-radio style="display: block;width: 30px;height: 30px" value="force">{{ $t('tip.forceSync') }}</a-radio>
      </a-radio-group>
      <template slot="footer">
        <mtc-button @click="handleCancleDbSync" text="button.close" style="margin-right: 8px;"/>
        <mtc-button type="primary" :loading="syncLoading" @click="handleDbSync" text="button.confirm" />
      </template>
    </a-modal>
    <a-modal v-model="confirmVisible" :closable="false" :footer="null" :width="466">
      <div class="ant-modal-confirm-body">
        <mtcLangPopover text="tip.tips">
          <a-icon type="question-circle" style="color: #faad14" />
          <span style="color: rgba(0, 0, 0, 0.85);font-weight: 500;font-size: 18px;">{{ $t('tip.tips') }}</span>
        </mtcLangPopover>
        <div class="ant-modal-confirm-content">
          {{ $t('tip.confirmRemove') }}<br>{{ $t('tip.pleaseConfirm') }}
        </div>
      </div>
      <div style="height: 50px;width: 100%">
        <div style="float: right;margin-top: 24px;">
          <mtc-button @click="confirmVisible = false" text="button.cancel" style="margin-right: 8px" />
          <mtc-button @click="doBatchDelete(0)" type="primary" text="button.remove" style="margin-bottom: 0;margin-left: 8px;" />
          <mtc-button @click="doBatchDelete(1)" type="primary" text="button.delete" style="margin-bottom: 0;margin-left: 8px;" />
        </div>
      </div>
    </a-modal>
  </a-card>
</template>

<script>
import OnlCgformHeadModal from './modules/OnlCgformHeadModal'
import { deleteAction, postAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import Clipboard from 'clipboard'
import EnhanceJs from './modules/EnhanceJs'
import EnhanceGroovy from './modules/EnhanceGroovy'
import EnhanceSql from './modules/EnhanceSql'
import EnhanceJava from './modules/EnhanceJava'
import TransDb2Online from './modules/TransDb2Online'
import CodeGenerator from './modules/CodeGenerator'
import OnlCgformButtonList from './button/OnlCgformButtonList'
import OnlEnhanceJavaList from './enhance/OnlEnhanceJavaList'
import OnlEnhanceSqlList from './enhance/OnlEnhanceSqlList'
import OnlEnhanceGroovyList from './enhance/OnlEnhanceGroovyList'

import { filterObj } from '@/utils/util'
import AuthManager from './auth/AuthManager'
import AuthSetter from './auth/AuthSetter'

export default {
  name: 'OnlCgformHeadList',
  mixins: [JeecgListMixin],
  components: {
    OnlCgformHeadModal,
    EnhanceJs,
    EnhanceSql,
    EnhanceJava,
    TransDb2Online,
    CodeGenerator,
    OnlCgformButtonList,
    AuthManager,
    EnhanceGroovy,
    AuthSetter,
    OnlEnhanceJavaList,
    OnlEnhanceSqlList,
    OnlEnhanceGroovyList
  },
  data() {
    return {
      description: 'Online表单开发管理页面',
      // 表头
      columns: [
        {
          title: '#',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          // title: '表类型',
          slotName: 'tableHeader.tableType',
          align: 'center',
          sorter: true,
          dataIndex: 'tableType',
          scopedSlots: { title: 'tableHeader.tableType' },
          customRender: (text, record) => {
            let tbTypeText = this.$filterDictText(this.tableTypeDictOptions, text)
            if (record.isTree === 'Y') {
              tbTypeText += '(树)'
            }
            if (record.themeTemplate === 'innerTable') {
              tbTypeText += '(内嵌)'
            } else if (record.themeTemplate === 'erp') {
              tbTypeText += '(ERP)'
            } else if (record.themeTemplate === 'tab') {
              tbTypeText += '(TAB)'
            }
            return tbTypeText
          }
        },
        {
          // title: '表名',
          slotName: 'tableHeader.tableName',
          sorter: true,
          align: 'center',
          scopedSlots: { title: 'tableHeader.tableName' },
          dataIndex: 'tableName'
        },
        {
          // title: '表描述',
          slotName: 'tableHeader.tableDescription',
          align: 'center',
          scopedSlots: { title: 'tableHeader.tableDescription' },
          dataIndex: 'tableTxt'
        },
        {
          // title: '版本',
          slotName: 'tableHeader.version',
          align: 'center',
          scopedSlots: { title: 'tableHeader.version' },
          dataIndex: 'tableVersion'
        },
        {
          // title: '同步状态',
          slotName: 'tableHeader.syncStatus',
          align: 'center',
          sorter: true,
          dataIndex: 'isDbSynch',
          scopedSlots: { customRender: 'dbsync', title: 'tableHeader.syncStatus' }
        },
        {
          // title: '创建时间',
          slotName: 'tableHeader.creationTime',
          align: 'center',
          scopedSlots: { title: 'tableHeader.creationTime' },
          sorter: true,
          dataIndex: 'createTime'
        },
        {
          // title: '操作',
          slotName: 'tableHeader.operation',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action', title: 'tableHeader.operation' }
        }
      ],
      superQueryFlag: false,
      superQueryParams: '',
      superQueryFieldList: [
        // { type: 'input', value: 'tableName', text: '表名' },
        // { type: 'select', value: 'tableType', text: '表类型', dictCode: 'cgform_table_type' },
        // { type: 'select', value: 'formCategory', text: '表单业务分类', dictCode: 'ol_form_biz_type' },
        // {
        //   type: 'select', value: 'isDbSynch', text: '同步状态', options: [
        //     { label: '已同步', value: 'Y' },
        //     { label: '未同步', value: 'N' }
        //   ]
        // },
        // { type: 'date', value: 'createTime', text: '创建时间' },
        // { type: 'input', value: 'tableTxt', text: '表描述' }
      ],
      url: {
        list: '/online/cgform/head/list',
        delete: '/online/cgform/head/delete',
        deleteBatch: '/online/cgform/head/deleteBatch',
        doDbSynch: '/online/cgform/api/doDbSynch/',
        removeRecord: '/online/cgform/head/removeRecord',
        copyOnline: '/online/cgform/head/copyOnline'
      },
      tableTypeDictOptions: [],
      sexDictOptions: [],
      syncModalVisible: false,
      syncFormId: '',
      synMethod: 'normal',
      syncLoading: false,
      onlineUrlTitle: '',
      onlineUrlVisible: false,
      onlineUrl: '',
      selectedRowKeys: [],
      selectedRows: [],
      confirmVisible: false
    }
  },
  created() {
    //初始化字典 - 表类型
    this.$initDictOptions('cgform_table_type').then((res) => {
      if (res.success) {
        this.tableTypeDictOptions = res.result
      }
    })
  },
  methods: {
    doDbSynch(id) {
      postAction(this.url.doDbSynch + id, { synMethod: '1' }).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.loadData()
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    getQueryParams() {
      //获取高级查询器条件
      let sqp = {}
      if (this.superQueryParams) {
        sqp[ 'superQueryParams' ] = encodeURI(this.superQueryParams)
        sqp[ 'superQueryMatchType' ] = this.superQueryMatchType
      }

      //获取查询条件
      var param = Object.assign(sqp, this.queryParam, this.isorter, this.filters)
      param.field = this.getQueryField()
      param.pageNo = this.ipagination.current
      param.pageSize = this.ipagination.pageSize
      param.copyType = 0
      return filterObj(param)
    },
    handleCancleDbSync() {
      this.syncModalVisible = false
    },
    handleDbSync() {
      this.syncLoading = true
      postAction(this.url.doDbSynch + this.syncFormId + '/' + this.synMethod).then((res) => {
        this.syncModalVisible = false
        this.syncLoading = false
        if (res.success) {
          this.$message.success(res.message)
          this.loadData()
        } else {
          this.$message.warning(res.message)
        }
      })
      setTimeout(() => {
        if (this.syncLoading) {
          this.syncModalVisible = false
          this.syncLoading = false
          // this.$message.success('网络延迟,已自动刷新!')
          this.loadData()
        }
      }, 10000)
    },
    openSyncModal(id) {
      this.syncModalVisible = true
      this.syncLoading = false
      this.syncFormId = id
    },
    goPageOnline(rd) {
      if (rd.themeTemplate === 'erp') {
        this.$router.push({ path: '/online/cgformErpList/' + rd.id })
      } else if (rd.themeTemplate === 'innerTable') {
        this.$router.push({ path: '/online/cgformInnerTableList/' + rd.id })
      } else if (rd.themeTemplate === 'tab') {
        this.$router.push({ path: '/online/cgformTabList/' + rd.id })
      } else {
        if (rd.isTree == 'Y') {
          this.$router.push({ path: '/online/cgformTreeList/' + rd.id })
        } else {
          this.$router.push({ path: '/online/cgformList/' + rd.id })
        }
      }
    },
    handleOnlineUrlClose() {
      this.onlineUrlTitle = ''
      this.onlineUrlVisible = false
    },
    handleOnlineUrlShow(record) {
      if (record.themeTemplate === 'erp') {
        this.onlineUrl = `/online/cgformErpList/${record.id}`
      } else if (record.themeTemplate === 'innerTable') {
        this.onlineUrl = `/online/cgformInnerTableList/${record.id}`
      } else if (record.themeTemplate === 'tab') {
        this.onlineUrl = `/online/cgformTabList/${record.id}`
      } else {
        if (record.isTree == 'Y') {
          this.onlineUrl = `/online/cgformTreeList/${record.id}`
        } else {
          this.onlineUrl = `/online/cgformList/${record.id}`
        }
      }
      this.onlineUrlVisible = true
      this.onlineUrlTitle = `${this.$t('tip.menuLink')}[${record.tableTxt}]`
    },
    handleRemoveRecord(id) {
      let that = this
      this.$confirm({
        title: this.$t('tip.confirmToRemoveThisRecord'),
        onOk() {
          deleteAction(that.url.removeRecord, { id: id }).then((res) => {
            if (res.success) {
              that.$message.success(this.$t('tip.successfulOperation'))
              that.loadData()
            } else {
              that.$message.warning(res.message)
            }
          })
        },
        onCancel() {
        }
      })
    },
    // 判断是否列表中选中了一条数据
    isSelectOne() {
      if (!this.selectedRowKeys || this.selectedRowKeys.length !== 1) {
        this.$message.warning(this.$t('tip.pleaseSelectARecord'))
        return false
      }
      return true
    },
    doEnhanceGroovy() {
      if (!this.isSelectOne()) return
      this.$refs.ehgroovy.show(this.selectedRows[ 0 ])
    },
    doEnhanceJs() {
      if (!this.isSelectOne()) return
      this.$refs.ehjs.show(this.selectedRows[ 0 ])
    },
    doEnhanceSql() {
      if (!this.isSelectOne()) return
      this.$refs.ehsql.show(this.selectedRows[ 0 ])
    },
    doEnhanceJava() {
      if (!this.isSelectOne()) return
      this.$refs.ehjava.show(this.selectedRowKeys[ 0 ])
    },
    doCgformButton() {
      if (!this.isSelectOne()) return
      this.$refs.btnList.show(this.selectedRowKeys[ 0 ])
      //this.$router.push({ path: '/online/cgformButton/' + this.selectedRowKeys[0] })
    },
    importOnlineForm() {
      this.$refs.transd2o.show()
    },
    transOk() {
      this.loadData()
    },
    goGenerateCode() {
      if (!this.isSelectOne()) return
      let row = this.selectedRows[ 0 ]
      if (!row) {
        this.$message.warning(this.$t('tip.pleaseSelectCurrentPageData'))
        return
      }
      if (!row.isDbSynch || row.isDbSynch == 'N') {
        this.$message.warning(this.$t('tip.pleaseSynchronizeTheDatabaseFirst'))
        return
      }
      if (row.tableType == 3) {
        this.$message.warning(this.$t('tip.pleaseSelectMainTable'))
        return
      }
      this.$refs.cg.show(this.selectedRowKeys[ 0 ])
    },
    onSelectChange(keys, rows) {
      this.selectedRowKeys = keys
      this.selectedRows = rows
    },
    onCopyUrl() {
      var clipboard = new Clipboard('.copy-this-text')
      clipboard.on('success', () => {
        clipboard.destroy()
        this.$message.success(this.$t('tip.copySuccessfully'))
        this.handleOnlineUrlClose()
      })
      clipboard.on('error', () => {
        this.$message.error(this.$t('tip.thisBrowserDoesNotSupportAutomaticCopying'))
        clipboard.destroy()
      })
    },
    showMyCopyInfo(id) {
      this.$router.push({ path: '/online/copyform/' + id })
    },
    copyConfig(id) {
      postAction(`${this.url.copyOnline}?code=${id}`).then(res => {
        if (res.success) {
          this.$message.success(this.$t('tip.copySuccessfully'))
          this.loadData()
        } else {
          this.$message.error(res.message)
        }
      })
    },
    batchDeleteCust() {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!')
        return
      }
      if (!this.isSelectOne()) return
      this.confirmVisible = true

    },
    doBatchDelete(flag) {
      var ids = ''
      for (var a = 0; a < this.selectedRowKeys.length; a++) {
        ids += this.selectedRowKeys[ a ] + ','
      }
      var that = this
      this.loading = true
      deleteAction(that.url.deleteBatch, { ids: ids, flag: flag }).then((res) => {
        if (res.success) {
          this.$message.success(res.message)
          this.loadData()
          this.onClearSelected()
        } else {
          this.$message.warning(res.message)
        }
      }).finally(() => {
        this.loading = false
        this.confirmVisible = false
      })
    },
    goAuthConfig(id) {
      this.$refs.authManager.show(id)
    },
    doAuthConfig(id) {
      this.$refs.authSetter.show(id)
    }

  }
}
</script>

<style lang="less" scoped>
/** 横向滚动设置配合样式 */
.ant-table td, th {
  white-space: nowrap;
}

.anty-row-operator button {
  margin: 0 5px
}

.ant-btn-danger {
  background-color: #ffffff
}

.valid-error-cust {
  .ant-select-selection {
    border: 2px solid #f5222d;
  }
}
</style>